import { ViewSupport41Container } from "../../../containers/SupportSystem/ViewReports/ViewSupport41Container"
export function ViewSupport41Page() {
    return (
        <ViewSupport41Container />
    )
}